import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './tender-group-view-styles';

interface TenderAmountDueProps {
  amountDue: number;
  totalLabel?: string;
  currencyCode?: string;
  align?: string;
}

const TenderAmountDue = ({
  amountDue,
  currencyCode,
  align,
  totalLabel,
}: TenderAmountDueProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  let textAlignClass = 'textAlignCenter';
  switch (align) {
    case 'left':
      textAlignClass = 'textAlignLeft';
      break;
    case 'right':
      textAlignClass = 'textAlignRight';
      break;
    default:
      textAlignClass = 'textAlignCenter';
  }
  const isTenderExchangeRefund = useSelector(
    (state: AppState): boolean =>
      !!state.tenderExchange.tenderExchangeDetails.isRefundScreenVisible,
  );

  //TODO check for return state
  if ((!totalLabel && amountDue < 0) || isTenderExchangeRefund) {
    totalLabel = t('TenderingView_RefundDue');
  }

  return (
    <Grid container direction='column'>
      <Grid item className={`${classes.total} ${textAlignClass}`} data-testid='tender-group-total'>
        {`${convertCurrency(amountDue, currencyCode)}`}
      </Grid>
      <Grid
        item
        data-testid='tender-group-total-label'
        className={`${classes.totalLabel} ${textAlignClass} ${
          !totalLabel ? '' : classes.customTopLabel
        }`}
      >
        {!totalLabel ? t('TenderingView_BalanceDue') : totalLabel}
      </Grid>
    </Grid>
  );
};

export default TenderAmountDue;
